module.exports = __webpack_public_path__ + "img/empty.276c05f0.png";